/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator){
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready () {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        )
      },
      registered () {
        console.log('Service worker has been registered.');
      },
      cached () {
      },
      updatefound () {
      },
      updated () {
      },
      offline () {
      },
      error (error) {
        console.error('Error during service worker registration:', error)
      }
    })

  }
}